module.exports = __webpack_public_path__ + "img/compare.f0a5ee64.png";